import _ from 'lodash'
import Wizard from 'scoreboard/components/wizard'
import FilterSelection from 'scoreboard/reports/wizard/common/filters-selection'
import DateFilterWizard from 'scoreboard/reports/common/filter/date-filter-wizard'
import FilterDetail from 'scoreboard/reports/wizard/common/filter-detail'
import ReportsWizard from 'scoreboard/reports/wizard/reports-wizard'
import ReportsWizardInfo from 'scoreboard/reports/wizard/reports-wizard-info'
import appDisplay from 'scoreboard/components/app-display'

const NonDatasetReportFilterWizard = Wizard.extend({

	/**
	 * Creates a filter wizard suitable for non dataset reports
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 */
	initialize: function(options = {}) {
		this.options = options
		this.options.wizard = this
		this.simpleFilterPath = [FilterSelection]
		Wizard.prototype.initialize.call(this, _.defaults({}, options, {
			views: this.simpleFilterPath
		}))
	},

	_updatePath: function(views = []) {
		let v = [].concat(this.simpleFilterPath, views)
		this.setViews(v)
		this.render({el: this.currentView.el})
	},

	_updateDatePath: function(operator) {
		this._updatePath(DateFilterWizard.viewsByOperator(operator).slice(1))
	},

	_view: function(options) {
		let view = Wizard.prototype._view.call(this, options)
		this.currentView = view

		this.listenTo(view, 'change:filterMeta', meta => {
			this.filterKey = view.filterKey
			if (meta.path) {
				//if a path is defined, we're going to use the report-wizard
				//to render it
				let model = new ReportsWizardInfo(meta)
				let wizard = new ReportsWizard({model})
				wizard.once('done', filter => {
					this.filterKey = meta.filterKey
					view.trigger('done', filter.attributes)
				})
				appDisplay.dialog(wizard)
				this._updatePath()
			} else if (meta.filterType == 'date') {
				this._updateDatePath(view.filterDetailView.gather().operator)
				this.listenTo(view.filterDetailView, 'change:operator', this._updateDatePath.bind(this))
			} else if (meta.allowInlineDisplay == false) {
				this._updatePath([FilterDetail])
			} else {
				this._updatePath()
			}
		})

		this.listenTo(view, 'next', (meta, filterData) => {
			this.filterKey = meta.filterKey
			if (this.views.length == this.step) {
				view.trigger('done', filterData)
			} else {
				this.next(_.assign({data: filterData}, meta))
			}
		})

		this.listenTo(view, 'done', val => {
			this.trigger('done', val, this.filterKey)
		})
		return view
	},

	back: function(options) {
		//if going back, reset to the simple filter view since all but 2 of the filters are inlinable
		//this is sorta hacky, but it's easy and for now we don't have many complicated filters that use
		//multiple steps, so until we need to support that this should work fine.
		this.setViews(this.simpleFilterPath)
		Wizard.prototype.back.call(this, options)
	}

})

export default NonDatasetReportFilterWizard
NonDatasetReportFilterWizard.__filename__ = 'reports/wizard/common/non-dataset-report-filter-wizard.js'
